import { type ReactElement } from "react";
import { ChatLoadedThreadSurface } from "./ChatLoadedThreadSurface";
import {
  buildChatLoadedThreadSurfaceProps,
  type LoadedSurfaceInput,
} from "./buildChatLoadedThreadSurfaceProps";

export function ChatLoadedThreadRuntime(props: LoadedSurfaceInput): ReactElement {
  return <ChatLoadedThreadSurface {...buildChatLoadedThreadSurfaceProps(props)} />;
}
